import * as React from 'react'
import type {SVGProps} from 'react'
const SvgPhone = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill="#0C5641"
            fillRule="evenodd"
            d="M3.218 6.924a13.46 13.46 0 0 0 5.858 5.858l1.955-1.955c.24-.24.596-.32.907-.214a10.1 10.1 0 0 0 3.173.507c.489 0 .889.4.889.889v3.102c0 .489-.4.889-.889.889C6.764 16 0 9.236 0 .889 0 .4.4 0 .889 0H4c.489 0 .889.4.889.889 0 1.111.178 2.178.507 3.173a.89.89 0 0 1-.223.907z"
        />
    </svg>
)
export default SvgPhone
